import {
  Button,
  CopyIcon,
  Dialog,
  IconButton,
  Input,
  Text,
  toast,
} from '@buffer-mono/popcorn'

import styles from './CredentialsDialog.module.css'

import type { JSX } from 'react'

interface CredentialsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  clientId: string
  clientSecret?: string | null
}

export function CredentialsDialog({
  open,
  onOpenChange,
  clientId,
  clientSecret,
}: CredentialsDialogProps): JSX.Element {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content size="medium">
        <Dialog.Header>
          <Dialog.Title>Client Credentials</Dialog.Title>
          <Dialog.Description>
            Use these credentials to integrate with the Buffer API.
          </Dialog.Description>
        </Dialog.Header>
        <Dialog.Body className={styles.body}>
          <div className={styles.field}>
            <Text weight="medium" className={styles.fieldLabel}>
              Client ID
            </Text>
            <Input
              id="client-id"
              className={styles.fieldInput}
              value={clientId}
              readOnly
              size="large"
            />
            <IconButton
              label="Copy Client ID"
              variant="tertiary"
              onClick={(): void => {
                void navigator.clipboard.writeText(clientId)
                toast.success('Client ID copied')
              }}
            >
              <CopyIcon />
            </IconButton>
          </div>
          {clientSecret && (
            <div className={styles.field}>
              <Text weight="medium" className={styles.fieldLabel}>
                Client Secret
              </Text>
              <Input
                id="client-secret"
                className={styles.fieldInput}
                type="password"
                value={clientSecret}
                readOnly
                size="large"
              />
              <IconButton
                label="Copy Client Secret"
                variant="tertiary"
                onClick={(): void => {
                  void navigator.clipboard.writeText(clientSecret)
                  toast.success('Client Secret copied')
                }}
              >
                <CopyIcon />
              </IconButton>
            </div>
          )}
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Close>
            <Button variant="tertiary">Close</Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
